import React, {useState} from "react";
import {Box} from "@mui/system";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {description, userInviteActionType, userInviteStatus} from "_constants";
import BasicOptionsMenu from "../../../common/BasicOptionsMenu";
import useModalSetup from "../../../hooks/useModalSetup";
import UserInviteActionModal from "./UserInviteActionModal";
import {useSelector} from "react-redux";

export default function UserInviteActions({ userInvite }) {
    const [actionType, setActionType] = useState({});
    const { handleOpenModal, handleCloseModal, openModal } = useModalSetup();
    const { inviteStatus, id } = userInvite || {};
    const {selectedUserInvite, loadingResend, loadingRevoke, loadingUnrevoke} = useSelector(state => state.userInvite);

    const is = {
        accepted: inviteStatus === userInviteStatus.ACCEPTED,
        expired: inviteStatus === userInviteStatus.EXPIRED,
        revoked: inviteStatus === userInviteStatus.REVOKED,
        selected: id === selectedUserInvite?.id
    };

    const options = [
        {
            id: userInviteActionType.RESEND,
            name: 'Resend',
            disabled: is.accepted,
            description: description.RESEND,
            isSelected: is.selected && loadingResend
        },
        {
            id: userInviteActionType.REVOKE,
            name: 'Revoke',
            disabled: is.accepted || is.expired,
            visible: !is.revoked,
            description: description.REVOKE,
            isSelected: is.selected && loadingRevoke
        },
        {
            id: userInviteActionType.UNREVOKE,
            name: 'Unrevoke',
            disabled: is.accepted,
            visible: is.revoked,
            description: description.UNREVOKE,
            isSelected: is.selected && loadingUnrevoke
        },
    ].filter(({ visible }) => visible !== false);

    const handleSelection = (selectedAction) => {
        setActionType(selectedAction);
        handleOpenModal();
    }

    return (
        <Box sx={{}}>
            <BasicOptionsMenu
                userInvite={userInvite}
                options={options}
                optionsDisabled={false}
                handleSelection={handleSelection}
                icon={<MoreVertIcon sx={styles.icon}/>}
            />
            <UserInviteActionModal
                title={actionType?.name ? `${actionType.name} Invitation` : 'Confirm action'}
                open={openModal}
                handleClose={handleCloseModal}
                userInvite={userInvite}
                actionType={actionType}
            />
        </Box>
    )
}

const styles = {
    icon: {
        color:'#003300',
        fontSize: '22px'
    }
}